let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("EYiM3")).then(() => parcelRequire('lvs3G'));